import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProfessionClassModel } from '@digilize/shared/definitions/src';
import { BehaviorSubject, catchError, map, Observable, of, shareReplay, tap } from 'rxjs';

interface ProfessionClassesResponse {
  data: ProfessionClassModel[];
  records_total: number;
  records_filtered: number;
  draw: number;
}

@Injectable({ providedIn: 'root' })
export class ProfessionClassesApiService {
  private readonly http = inject(HttpClient);
  private readonly classes$$ = new BehaviorSubject<ProfessionClassModel[] | null>(null);
  private inflight$: Observable<ProfessionClassModel[]> | null = null;

  getProfessionClasses(): Observable<ProfessionClassModel[]> {
    const cached = this.classes$$.value;
    if (cached) {
      return of(cached);
    }
    if (this.inflight$) {
      return this.inflight$;
    }
    this.inflight$ = this.http
      .get<ProfessionClassesResponse>('/api/v1.0/profession-classes', { params: { length: 0 } })
      .pipe(
        map((res) => res.data ?? []),
        tap((classes) => this.classes$$.next(classes)),
        catchError(() => {
          this.inflight$ = null;
          return of([] as ProfessionClassModel[]);
        }),
        shareReplay(1)
      );
    return this.inflight$;
  }
}
